import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/equipment/equipment.actions';
import { load as loadEquiptmentCategory } from '../../../reducers/equipmentCategory/equipmentCategory.actions';
import { equipments, loading } from '../../../reducers/equipment/equipment.reducer';
import { equipmentCategories } from '../../../reducers/equipmentCategory/equipmentCategory.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminEquipments.css';
import ConnectedEquipmentForm from './EquipmentForm/EquipmentForm';
import SelectFormGroup from '../../Forms/SelectFormGroup/SelectFormGroup';

export class AdminEquipments extends React.Component {
  constructor() {
    super();
    this.state = {
      equipmentClass: undefined,
    };
  }

  componentDidMount() {
    this.props.load();
    this.props.loadClasses();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areEquipmentsLoading} />
        <Row style={{ 'margin-bottom': '15px' }}>
          <Col md={2} ><Button onClick={this.props.addEquipment} bsStyle="primary">Add New Equipment</Button></Col>
          <Col md={2} >
            <SelectFormGroup
              inputRef={(el) => { this.inputEl = el; }}
              onChange={() => this.setState({ equipmentClass: this.inputEl.value })}
              options={this.props.equipmentClasses}
            />
          </Col>
        </Row>
        {this.props.equipments(this.state.equipmentClass).map(equipment => (
          <Row key={equipment.id}>
            <Col>
              <ConnectedEquipmentForm equipment={equipment} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addEquipment} bsStyle="primary">Add New Equipment</Button></Col></Row>
      </span>
    );
  }
}

AdminEquipments.propTypes = {
  load: PropTypes.func.isRequired,
  loadClasses: PropTypes.func.isRequired,
  addEquipment: PropTypes.func.isRequired,
  areEquipmentsLoading: PropTypes.bool.isRequired,
  equipments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  equipmentClasses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areEquipmentsLoading: loading(state),
  equipments: classId => equipments(state, classId),
  equipmentClasses: equipmentCategories(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  loadClasses: () => dispatch(loadEquiptmentCategory()),
  addEquipment: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminEquipments);



// WEBPACK FOOTER //
// ./src/components/Admin/Equipment/AdminEquipments.jsx